import React from 'react'
import { Typography } from '../Typography/Typography'

type TitleProps = {
    title?: string
    style?: React.CSSProperties
}

const Title = ({ title, style }: TitleProps): JSX.Element => {
    return (
        <Typography tag="h2" size="L" style={{ ...style }}>
            {title}
        </Typography>
    )
}

export default Title
